export const LOCALIZATION_SCOPE = 'ai-panel';
